export enum PurgeTargetKey {
  LOBBY_LAYOUT = 'lobbyLayout',
  CATEGORY_LAYOUT = 'categoryLayout',
  LOBBY = 'lobby',
  GAME_DETAILS = 'gameDetails',
  ALL = 'all',
}

export interface PurgeTarget {
  key: PurgeTargetKey
  labelId: string
  endpoint: string
  tags: string[]
}

const LOBBY_TAGS = [
  'casino-lobby',
  'casino-lobby-base',
  'casino-lobby-category',
]
const GAME_DETAILS_TAGS = ['casino', 'games-details']

export const PURGE_TARGETS: Record<PurgeTargetKey, PurgeTarget> = {
  [PurgeTargetKey.LOBBY_LAYOUT]: {
    key: PurgeTargetKey.LOBBY_LAYOUT,
    labelId: 'casino.cachePurge.target.lobbyLayout',
    endpoint: '/lobby/layout',
    tags: ['casino-lobby', 'casino-lobby-base'],
  },
  [PurgeTargetKey.CATEGORY_LAYOUT]: {
    key: PurgeTargetKey.CATEGORY_LAYOUT,
    labelId: 'casino.cachePurge.target.categoryLayout',
    endpoint: '/lobby/layout/{categoryId}',
    tags: ['casino-lobby', 'casino-lobby-category'],
  },
  [PurgeTargetKey.LOBBY]: {
    key: PurgeTargetKey.LOBBY,
    labelId: 'casino.cachePurge.target.lobby',
    endpoint: '/lobby/*',
    tags: LOBBY_TAGS,
  },
  [PurgeTargetKey.GAME_DETAILS]: {
    key: PurgeTargetKey.GAME_DETAILS,
    labelId: 'casino.cachePurge.target.gameDetails',
    endpoint: '/games/{id}',
    tags: GAME_DETAILS_TAGS,
  },
  [PurgeTargetKey.ALL]: {
    key: PurgeTargetKey.ALL,
    labelId: 'casino.cachePurge.target.all',
    endpoint: '*',
    tags: [...LOBBY_TAGS, ...GAME_DETAILS_TAGS],
  },
}

export const LOBBY_PURGE_TARGETS: PurgeTargetKey[] = [
  PurgeTargetKey.LOBBY_LAYOUT,
  PurgeTargetKey.CATEGORY_LAYOUT,
  PurgeTargetKey.LOBBY,
]

export const ALL_PURGE_TARGETS: PurgeTargetKey[] = [
  PurgeTargetKey.LOBBY_LAYOUT,
  PurgeTargetKey.CATEGORY_LAYOUT,
  PurgeTargetKey.LOBBY,
  PurgeTargetKey.GAME_DETAILS,
  PurgeTargetKey.ALL,
]

export const CACHE_PURGE_PERMISSION = 'casino.cache.purge'

export const CACHE_PURGE_FEATURE_TOGGLE = 'casino:cache-purge'

export const isPurgeTargetKey = (value: unknown): value is PurgeTargetKey =>
  Object.values(PurgeTargetKey).includes(value as PurgeTargetKey)
